
import { defineComponent } from 'vue'
import hemisphereService from '@/services/hemisphere.service'
import useVuelidate from '@vuelidate/core'
import { required, minLength, sameAs } from '@/utils/i18n-validators'

export default defineComponent({
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      submitted: false,
      hashKey: '',
      userId: '',
      userBrand: '',
      changePasswordForm: {
        password: '',
        confirmationPassword: ''
      }
    }
  },
  computed: {
    isSubmitDisabled(): boolean {
      return this.v$.changePasswordForm.$invalid
    }
  },
  created() {
    this.userId = this.$route.params.user_id as string
    this.hashKey = this.$route.params.hash_key as string
    this.userBrand = this.$route.params.user_brand as string
  },
  validations() {
    return {
      changePasswordForm: {
        password: {
          required,
          minLength: minLength(6)
        },
        confirmationPassword: {
          required,
          sameAsPassword: sameAs(this.changePasswordForm.password)
        }
      }
    }
  },
  methods: {
    async submitChangePassword() {
      this.submitted = true
      this.v$.changePasswordForm.$touch()
      if (this.v$.changePasswordForm.$invalid) {
        return false // stop here if form is invalid
      } else {
        const resp = await hemisphereService.resetPassword(this.changePasswordForm.confirmationPassword, this.hashKey)
        if (resp) {
          this.$toast.add({
            severity: 'success',
            summary: this.$t('login-page.reset-password-success'),
            detail: this.$t('login-page.login-message'),
            life: 3000
          })
          this.$router.push('/login')
        } else {
          this.$toast.add({
            severity: 'error',
            summary: this.$t('validations.error-occured'),
            detail: this.$t('login-page.reset-password-error'),
            life: 3000
          })
        }
      }
    }
  }
})
